import { createSlice } from '@reduxjs/toolkit'

const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    modals: {
      discardChanges: {
        open: false,
        data: null,
        promise: null,
      },
      onboarding: {
        open: false,
        data: null,
        promise: null,
      },
    }
  },
  reducers: {
    setModalOpen(state, { payload }) {
      if (state.modals.hasOwnProperty(payload.name)) {
        state.modals[payload.name].open = payload.value;
        state.modals[payload.name].data = payload.data;
      }
    },
    clearModalData(state, { payload }) {
      if (state.modals.hasOwnProperty(payload.name)) {
        state.modals[payload.name].data = null;
      }
    }
  }
});

export const { setModalOpen, clearModalData } = modalSlice.actions;
export const modalReducer = modalSlice.reducer;

export default modalSlice;

export const openModal = (name) => (dispatch, getState) => {
  dispatch(setModalOpen({ name, value: true }));
};

export const closeModal = (name, data) => (dispatch) => {
  dispatch(setModalOpen({ name, data, value: false }));

  setTimeout(() => {
    dispatch(clearModalData({ name }))
  }, 200);
};